import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const DeltaChip = ({ value, label, showPercent = true }) => {
  if (value === null || value === undefined) return null;
  const isPositive = value > 0;
  const isNegative = value < 0;
  const color = isPositive ? 'success' : isNegative ? 'error' : 'default';
  const Icon = isPositive ? TrendingUpIcon : isNegative ? TrendingDownIcon : TrendingFlatIcon;
  const displayValue = showPercent
    ? `${value >= 0 ? '+' : ''}${value.toFixed(1)}%`
    : `${value >= 0 ? '+' : ''}${value.toFixed(0)}`;
  return (
    <Chip
      icon={<Icon sx={{ fontSize: '0.9rem !important' }} />}
      label={label ? `${label} ${displayValue}` : displayValue}
      color={color}
      size="small"
      variant="outlined"
      sx={{ height: 24, '& .MuiChip-label': { px: 1, fontSize: '0.75rem' } }}
    />
  );
};

DeltaChip.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  showPercent: PropTypes.bool,
};

export default DeltaChip;